import {
	tradesumByCanteen2,
	tradesumByCanteenexport,
	tradesumByDept,
	tradesumByDept2,
	tradesumByDeptexport,
	tradesumByMachine,
	tradesumByPersonal,
	personalMoneySum,
	dishSaleSum,
	saleAnalysisDetail,
	sysOperationForm,
	tradesumByNuclearmode,
	getRechargeSum,
	getRechargeSumexport,
	getWithdrawalRecord,
	getWithdrawalRecordNew,
	getRechargeDeptSum,
	tradesumByPsnType,
	getOrdTradeDetail,
	getOperatorCount,
	personChangecard,
	overDeliver,
	getgongyingshang,
	getgongyingshangmingxi,
	getfenleihuizong,
	getfenleihuizongdan,
	getShitangcaipinxiaoshou,
	getCaipintongji,
	getCancitongji,
	getRenyuantongji,
	getDepartmentxiaofei,
	getDeptpayxiaofei,
	getDeptpayxiaofei2,
	getDeptpayxiaofeiexport,
	getDatepaymentpage,
	getPsnpaymentpage,
	getJiucandetail,
	getDeptjsjhpaymentsum,
	personAcccardsum,
	getCustordnum,
	exportCancibuties,
	getShuikongdetail,
	getShuikonghuizong,
	getPeoplejiucan,
	getHolidayssum,
	getHolidayssumdept,
	getCustdailysum,
	getOrgsum,
	getOrderdetail,
	getOrdersum,
	getXiaofeiliushui,
	getXiaofeijisum,
	getXiaofeijidishsum,
	getshopxiaoshousum,
	getXiaofeisum,
	getRechargeSum2,
	tradesumByPayType,
	getLibaiCustMonthTradeSum,
	getLibaiCustMonthOrdSum,
	getLibaiTradeInfo,
	getCustordnumsub,
	getRechargeform,
	getRechargeSum3,
	tradesumByPayType2,
	tradesumByPayTypeexport,
	tradesumCanciByPayTypeexport,
	getOptsum,
	getFlowTotalByPageexport,
	getneedredress,
	redressupdate,
	getneedredressdetail,
	getOrgordnumdz,
	exportOrgordnumdz
} from '@/api/reportcenter'

const state = {}
const mutations = {}

const actions = {
	getFlowTotalByPageexport ({}, data) {
		return new Promise((resolve, reject) => {
			getFlowTotalByPageexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByCanteen2 ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByCanteen2(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByCanteenexport ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByCanteenexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByDept ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByDept(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByDept2 ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByDept2(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByDeptexport ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByDeptexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByMachine ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByMachine(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByPersonal ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByPersonal(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	personalMoneySum ({}, data) {
		return new Promise((resolve, reject) => {
			personalMoneySum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByNuclearmode ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByNuclearmode(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	dishSaleSum ({}, data) {
		return new Promise((resolve, reject) => {
			dishSaleSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	saleAnalysisDetail ({}, data) {
		return new Promise((resolve, reject) => {
			saleAnalysisDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	sysOperationForm ({}, data) {
		return new Promise((resolve, reject) => {
			sysOperationForm(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeSum ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeSum2 ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeSum2(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeSum3 ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeSum3(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeSumexport ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeSumexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getWithdrawalRecordNew ({}, data) {
		return new Promise((resolve, reject) => {
			getWithdrawalRecordNew(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getWithdrawalRecord ({}, data) {
		return new Promise((resolve, reject) => {
			getWithdrawalRecord(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeDeptSum ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeDeptSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByPsnType ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByPsnType(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrdTradeDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getOrdTradeDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOperatorCount ({}, data) {
		return new Promise((resolve, reject) => {
			getOperatorCount(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	personChangecard ({}, data) {
		return new Promise((resolve, reject) => {
			personChangecard(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	overDeliver ({}, data) {
		return new Promise((resolve, reject) => {
			overDeliver(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getfenleihuizongdan ({}, data) {
		return new Promise((resolve, reject) => {
			getfenleihuizongdan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getfenleihuizong ({}, data) {
		return new Promise((resolve, reject) => {
			getfenleihuizong(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getgongyingshang ({}, data) {
		return new Promise((resolve, reject) => {
			getgongyingshang(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getgongyingshangmingxi ({}, data) {
		return new Promise((resolve, reject) => {
			getgongyingshangmingxi(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShitangcaipinxiaoshou ({}, data) {
		return new Promise((resolve, reject) => {
			getShitangcaipinxiaoshou(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCaipintongji ({}, data) {
		return new Promise((resolve, reject) => {
			getCaipintongji(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDepartmentxiaofei ({}, data) {
		return new Promise((resolve, reject) => {
			getDepartmentxiaofei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCancitongji ({}, data) {
		return new Promise((resolve, reject) => {
			getCancitongji(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRenyuantongji ({}, data) {
		return new Promise((resolve, reject) => {
			getRenyuantongji(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDeptpayxiaofei ({}, data) {
		return new Promise((resolve, reject) => {
			getDeptpayxiaofei(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDeptpayxiaofei2 ({}, data) {
		return new Promise((resolve, reject) => {
			getDeptpayxiaofei2(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDeptpayxiaofeiexport ({}, data) {
		return new Promise((resolve, reject) => {
			getDeptpayxiaofeiexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDatepaymentpage ({}, data) {
		return new Promise((resolve, reject) => {
			getDatepaymentpage(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPsnpaymentpage ({}, data) {
		return new Promise((resolve, reject) => {
			getPsnpaymentpage(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getJiucandetail ({}, data) {
		return new Promise((resolve, reject) => {
			getJiucandetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDeptjsjhpaymentsum ({}, data) {
		return new Promise((resolve, reject) => {
			getDeptjsjhpaymentsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	personAcccardsum ({}, data) {
		return new Promise((resolve, reject) => {
			personAcccardsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCustordnum ({}, data) {
		return new Promise((resolve, reject) => {
			getCustordnum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportCancibuties ({}, data) {
		return new Promise((resolve, reject) => {
			exportCancibuties(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShuikongdetail ({}, data) {
		return new Promise((resolve, reject) => {
			getShuikongdetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getShuikonghuizong ({}, data) {
		return new Promise((resolve, reject) => {
			getShuikonghuizong(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPeoplejiucan ({}, data) {
		return new Promise((resolve, reject) => {
			getPeoplejiucan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getHolidayssum ({}, data) {
		return new Promise((resolve, reject) => {
			getHolidayssum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getHolidayssumdept ({}, data) {
		return new Promise((resolve, reject) => {
			getHolidayssumdept(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCustdailysum ({}, data) {
		return new Promise((resolve, reject) => {
			getCustdailysum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrgsum ({}, data) {
		return new Promise((resolve, reject) => {
			getOrgsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByPayType ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByPayType(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCustordnumsub ({}, data) {
		return new Promise((resolve, reject) => {
			getCustordnumsub(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByPayType2 ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByPayType2(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumByPayTypeexport ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumByPayTypeexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	tradesumCanciByPayTypeexport ({}, data) {
		return new Promise((resolve, reject) => {
			tradesumCanciByPayTypeexport(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrderdetail ({}, data) {
		return new Promise((resolve, reject) => {
			getOrderdetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrdersum ({}, data) {
		return new Promise((resolve, reject) => {
			getOrdersum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getXiaofeiliushui ({}, data) {
		return new Promise((resolve, reject) => {
			getXiaofeiliushui(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getXiaofeijisum ({}, data) {
		return new Promise((resolve, reject) => {
			getXiaofeijisum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getXiaofeijidishsum ({}, data) {
		return new Promise((resolve, reject) => {
			getXiaofeijidishsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getshopxiaoshousum ({}, data) {
		return new Promise((resolve, reject) => {
			getshopxiaoshousum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getXiaofeisum ({}, data) {
		return new Promise((resolve, reject) => {
			getXiaofeisum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOptsum ({}, data) {
		return new Promise((resolve, reject) => {
			getOptsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLibaiCustMonthTradeSum ({}, data) {
		return new Promise((resolve, reject) => {
			getLibaiCustMonthTradeSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLibaiCustMonthOrdSum ({}, data) {
		return new Promise((resolve, reject) => {
			getLibaiCustMonthOrdSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLibaiTradeInfo ({}, data) {
		return new Promise((resolve, reject) => {
			getLibaiTradeInfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargeform ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargeform(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getneedredress ({}, data) {
		return new Promise((resolve, reject) => {
			getneedredress(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getneedredressdetail ({}, data) {
		return new Promise((resolve, reject) => {
			getneedredressdetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	redressupdate ({}, data) {
		return new Promise((resolve, reject) => {
			redressupdate(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrgordnumdz ({}, data) {
		return new Promise((resolve, reject) => {
			getOrgordnumdz(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportOrgordnumdz ({}, data) {
		return new Promise((resolve, reject) => {
			exportOrgordnumdz(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
